var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"_file",attrs:{"type":"file","name":"file","id":_vm.id,"accept":_vm.Accept,"multiple":Number(_vm.shuliang)>1},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }